const mezzoDevicesChecker = array => Object.values(array).every(elem => elem === 'N/A')

export default mezzoDevicesChecker
